import { render, staticRenderFns } from "./CreateIndustrialSectorPopup.vue?vue&type=template&id=1ed1df74&scoped=true&"
import script from "./CreateIndustrialSectorPopup.vue?vue&type=script&lang=js&"
export * from "./CreateIndustrialSectorPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed1df74",
  null
  
)

export default component.exports